import { FEEDBACK_REQUEST } from "../actions/utilities"

const INITIAL_STATE = {
    getTemplatesListingLoading: false,
    getTemplatesListingSuccess: false,
    getTemplatesListingFailure: false,
    getTemplatesListingError: null,
    templatesList: [],

    getQuestionListingLoading: false,
    getQuestionListingSuccess: false,
    getQuestionListingFailure: false,
    getQuestionListingError: null,
    questionsList: [],


    getFeedbackReviewsListingLoading: false,
    getFeedbackReviewsListingSuccess: false,
    getFeedbackReviewsListingFailure: false,
    getFeedbackReviewsListingError: null,
    feedbackReviewsList: [],

    getEvaluationListingLoading: false,
    getEvaluationListingSuccess: false,
    getEvaluationListingFailure: false,
    getEvaluationListingError: null,
    evaluationList: [],

    getGiveFeedbackLoading: false,
    getGiveFeedbackSuccess: false,
    getGiveFeedbackFailure: false,
    getGiveFeedbackError: null,
    giveFeedbacksList: [],

    addEvaluationLoading: false,
    addEvaluationSuccess: false,
    addEvaluationFailure: false,
    addEvaluationError: null,

    addAnswersLoading: false,
    addAnswersSuccess: false,
    addAnswersFailure: false,
    addAnswersError: null,

    addQuestionLoading: false,
    addQuestionSuccess: false,
    addQuestionFailure: false,
    addQuestionError: null,

    deleteQuestionLoading: false,
    deleteQuestionSuccess: false,
    deleteQuestionFailure: false,
    deleteQuestionError: null,

    addTemplateLoading: false,
    addTemplateSuccess: false,
    addTemplateFailure: false,
    addTemplateError: null,

    deleteTemplateLoading: false,
    deleteTemplateSuccess: false,
    deleteTemplateFailure: false,
    deleteTemplateError: null,

    getAnswersByEvaluationIdLoading: false,
    getAnswersByEvaluationIdSuccess: false,
    getAnswersByEvaluationIdFailure: false,
    getAnswersByEvaluationIdError: null,
    AnswersByEvaluation: [],


    completeEvaluationLoading: false,
    completeEvaluationSuccess: false,
    completeEvaluationFailure: false,
    completeEvaluationError: null,

    getFilteredEvaluationIdLoading: false,
    getFilteredEvaluationIdSuccess: false,
    getFilteredEvaluationIdFailure: false,
    getFilteredEvaluationIdError: null,
    FilteredEvaluation: [],
};

export const feedbackReducer = (state = INITIAL_STATE, action) => {
    let templateArr;
    let questionArr;
    let evaluationArr;
    switch (action.type) {
        case FEEDBACK_REQUEST.COMPLETE_EVALUATION_REQUEST:
            return {
                ...state,
                completeEvaluationLoading: true,
                completeEvaluationSuccess: false,
                completeEvaluationFailure: false,
                completeEvaluationError: null,
            }
        case FEEDBACK_REQUEST.COMPLETE_EVALUATION_FAILURE:
            return {
                ...state,
                completeEvaluationLoading: false,
                completeEvaluationSuccess: false,
                completeEvaluationFailure: true,
                completeEvaluationError: action.payload,
            }
        case FEEDBACK_REQUEST.COMPLETE_EVALUATION_SUCCESS:
            return {
                ...state,
                completeEvaluationLoading: false,
                completeEvaluationSuccess: true,
                completeEvaluationFailure: false,
                completeEvaluationError: null,
            }
        case FEEDBACK_REQUEST.ADD_ANSWERS_REQUEST:
            return {
                ...state,
                addAnswersLoading: true,
                addAnswersSuccess: false,
                addAnswersFailure: false,
                addAnswersError: null,
            }
        case FEEDBACK_REQUEST.ADD_ANSWERS_FAILURE:
            return {
                ...state,
                addAnswersLoading: false,
                addAnswersSuccess: false,
                addAnswersFailure: true,
                addAnswersError: action.payload,
            }
        case FEEDBACK_REQUEST.ADD_ANSWERS_SUCCESS:
            return {
                ...state,
                addAnswersLoading: false,
                addAnswersSuccess: true,
                addAnswersFailure: false,
                addAnswersError: null,
            }
        case FEEDBACK_REQUEST.GET_GIVE_FEEDBACK_REQUEST:
            return {
                ...state,
                getGiveFeedbackLoading: true,
                getGiveFeedbackSuccess: false,
                getGiveFeedbackFailure: false,
                getGiveFeedbackError: null,
            }
        case FEEDBACK_REQUEST.GET_GIVE_FEEDBACK_FAILURE:
            return {
                ...state,
                getGiveFeedbackLoading: false,
                getGiveFeedbackSuccess: false,
                getGiveFeedbackFailure: true,
                getGiveFeedbackError: action.payload,
            }
        case FEEDBACK_REQUEST.GET_GIVE_FEEDBACK_SUCCESS:
            return {
                ...state,
                getGiveFeedbackLoading: false,
                getGiveFeedbackSuccess: true,
                getGiveFeedbackFailure: false,
                getGiveFeedbackError: null,
                giveFeedbacksList: action.payload,
            }
        case FEEDBACK_REQUEST.ADD_EVALUATION_REQUEST:
            return {
                ...state,
                addEvaluationLoading: true,
                addEvaluationSuccess: false,
                addEvaluationFailure: false,
                addEvaluationError: null,
            }
        case FEEDBACK_REQUEST.ADD_EVALUATION_FAILURE:
            return {
                ...state,
                addEvaluationLoading: false,
                addEvaluationSuccess: false,
                addEvaluationFailure: true,
                addEvaluationError: action.payload,
            }
        case FEEDBACK_REQUEST.ADD_EVALUATION_SUCCESS:
            evaluationArr = state.evaluationList;
            evaluationArr.push(action.payload)
            return {
                ...state,
                addEvaluationLoading: false,
                addEvaluationSuccess: true,
                addEvaluationFailure: false,
                addEvaluationError: null,
                evaluationList: evaluationArr,
            }
        case FEEDBACK_REQUEST.GET_EVALUATION_LISTING_REQUEST:
            return {
                ...state,
                getEvaluationListingLoading: true,
                getEvaluationListingSuccess: false,
                getEvaluationListingFailure: false,
                getEvaluationListingError: null,
            }
        case FEEDBACK_REQUEST.GET_EVALUATION_LISTING_FAILURE:
            return {
                ...state,
                getEvaluationListingLoading: false,
                getEvaluationListingSuccess: false,
                getEvaluationListingFailure: true,
                getEvaluationListingError: action.payload,
            }
        case FEEDBACK_REQUEST.GET_EVALUATION_LISTING_SUCCESS:
            return {
                ...state,
                getEvaluationListingLoading: false,
                getEvaluationListingSuccess: true,
                getEvaluationListingFailure: false,
                getEvaluationListingError: null,
                evaluationList: action.payload,
            }
        case FEEDBACK_REQUEST.GET_FEEDBACK_REVIEWS_LISTING_REQUEST:
            return {
                ...state,
                getFeedbackReviewsListingLoading: true,
                getFeedbackReviewsListingSuccess: false,
                getFeedbackReviewsListingFailure: false,
                getFeedbackReviewsListingError: null,
            }
        case FEEDBACK_REQUEST.GET_FEEDBACK_REVIEWS_LISTING_FAILURE:
            return {
                ...state,
                getFeedbackReviewsListingLoading: false,
                getFeedbackReviewsListingSuccess: false,
                getFeedbackReviewsListingFailure: true,
                getFeedbackReviewsListingError: action.payload,
            }
        case FEEDBACK_REQUEST.GET_FEEDBACK_REVIEWS_LISTING_SUCCESS:
            return {
                ...state,
                getFeedbackReviewsListingLoading: false,
                getFeedbackReviewsListingSuccess: true,
                getFeedbackReviewsListingFailure: false,
                getFeedbackReviewsListingError: null,
                feedbackReviewsList: action.payload,
            }
        case FEEDBACK_REQUEST.RESET_DELETE_QUESTION:
            return {
                ...state,
                deleteQuestionLoading: false,
                deleteQuestionSuccess: false,
                deleteQuestionFailure: false,
                deleteQuestionError: null,
            }
        case FEEDBACK_REQUEST.DELETE_QUESTION_REQUEST:
            return {
                ...state,
                deleteQuestionLoading: true,
                deleteQuestionSuccess: false,
                deleteQuestionFailure: false,
                deleteQuestionError: null,
            }
        case FEEDBACK_REQUEST.DELETE_QUESTION_FAILURE:
            return {
                ...state,
                deleteQuestionLoading: false,
                deleteQuestionSuccess: false,
                deleteQuestionFailure: true,
                deleteQuestionError: action.payload,
            }
        case FEEDBACK_REQUEST.DELETE_QUESTION_SUCCESS:
            questionArr = state.questionsList;
            for (let i = 0; i < questionArr.length; i++) {
                if (questionArr[i].questionId === action.payload) {
                    questionArr.splice(i, 1)
                }
            }
            return {
                ...state,
                deleteQuestionLoading: false,
                deleteQuestionSuccess: true,
                deleteQuestionFailure: false,
                deleteQuestionError: null,
                questionsList: questionArr,
            }
        case FEEDBACK_REQUEST.ADD_QUESTION_REQUEST:
            return {
                ...state,
                addQuestionLoading: true,
                addQuestionSuccess: false,
                addQuestionFailure: false,
                addQuestionError: null,
            }
        case FEEDBACK_REQUEST.ADD_QUESTION_FAILURE:
            return {
                ...state,
                addQuestionLoading: false,
                addQuestionSuccess: false,
                addQuestionFailure: true,
                addQuestionError: action.payload,
            }
        case FEEDBACK_REQUEST.ADD_QUESTION_SUCCESS:
            questionArr = state.questionsList;
            questionArr.push(action.payload)
            return {
                ...state,
                addQuestionLoading: false,
                addQuestionSuccess: true,
                addQuestionFailure: false,
                addQuestionError: null,
                questionsList: questionArr,
            }
        case FEEDBACK_REQUEST.GET_QUESTION_LISTING_REQUEST:
            return {
                ...state,
                getQuestionListingLoading: true,
                getQuestionListingSuccess: false,
                getQuestionListingFailure: false,
                getQuestionListingError: null,
            }
        case FEEDBACK_REQUEST.GET_QUESTION_LISTING_FAILURE:
            return {
                ...state,
                getQuestionListingLoading: false,
                getQuestionListingSuccess: false,
                getQuestionListingFailure: true,
                getQuestionListingError: action.payload,
            }
        case FEEDBACK_REQUEST.GET_QUESTION_LISTING_SUCCESS:
            return {
                ...state,
                getQuestionListingLoading: false,
                getQuestionListingSuccess: true,
                getQuestionListingFailure: false,
                getQuestionListingError: null,
                questionsList: action.payload,
            }
        case FEEDBACK_REQUEST.RESET_DELETE_TEMPLATE:
            return {
                ...state,
                deleteTemplateLoading: false,
                deleteTemplateSuccess: false,
                deleteTemplateFailure: false,
                deleteTemplateError: null,
            }
        case FEEDBACK_REQUEST.DELETE_TEMPLATE_REQUEST:
            return {
                ...state,
                deleteTemplateLoading: true,
                deleteTemplateSuccess: false,
                deleteTemplateFailure: false,
                deleteTemplateError: null,
            }
        case FEEDBACK_REQUEST.DELETE_TEMPLATE_FAILURE:
            return {
                ...state,
                deleteTemplateLoading: false,
                deleteTemplateSuccess: false,
                deleteTemplateFailure: true,
                deleteTemplateError: action.payload,
            }
        case FEEDBACK_REQUEST.DELETE_TEMPLATE_SUCCESS:
            templateArr = state.templatesList;
            for (let i = 0; i < templateArr.length; i++) {
                if (templateArr[i].formId === action.payload) {
                    templateArr.splice(i, 1)
                }
            }
            return {
                ...state,
                deleteTemplateLoading: false,
                deleteTemplateSuccess: true,
                deleteTemplateFailure: false,
                deleteTemplateError: null,
                templatesList: templateArr,
            }
        case FEEDBACK_REQUEST.ADD_TEMPLATE_REQUEST:
            return {
                ...state,
                addTemplateLoading: true,
                addTemplateSuccess: false,
                addTemplateFailure: false,
                addTemplateError: null,
            }
        case FEEDBACK_REQUEST.ADD_TEMPLATE_FAILURE:
            return {
                ...state,
                addTemplateLoading: false,
                addTemplateSuccess: false,
                addTemplateFailure: true,
                addTemplateError: action.payload,
            }
        case FEEDBACK_REQUEST.ADD_TEMPLATE_SUCCESS:
            templateArr = state.templatesList;
            templateArr.push(action.payload)
            return {
                ...state,
                addTemplateLoading: false,
                addTemplateSuccess: true,
                addTemplateFailure: false,
                addTemplateError: null,
                templatesList: templateArr,
            }
        case FEEDBACK_REQUEST.GET_TEMPLATES_LISTING_REQUEST:
            return {
                ...state,
                getTemplatesListingLoading: true,
                getTemplatesListingSuccess: false,
                getTemplatesListingFailure: false,
                getTemplatesListingError: null,
            }
        case FEEDBACK_REQUEST.GET_TEMPLATES_LISTING_FAILURE:
            return {
                ...state,
                getTemplatesListingLoading: false,
                getTemplatesListingSuccess: false,
                getTemplatesListingFailure: true,
                getTemplatesListingError: action.payload,
            }
        case FEEDBACK_REQUEST.GET_TEMPLATES_LISTING_SUCCESS:
            return {
                ...state,
                getTemplatesListingLoading: false,
                getTemplatesListingSuccess: true,
                getTemplatesListingFailure: false,
                getTemplatesListingError: null,
                templatesList: action.payload,
            }
        case FEEDBACK_REQUEST.GET_ANSWERS_BYEVALUATION_ID_REQUEST:
            return {
                ...state,
                getAnswersByEvaluationIdLoading: true,
                getAnswersByEvaluationIdSuccess: false,
                getAnswersByEvaluationIdFailure: false,
                getAnswersByEvaluationIdError: null,
            }
        case FEEDBACK_REQUEST.GET_ANSWERS_BYEVALUATION_ID_FAILURE:
            return {
                ...state,
                getAnswersByEvaluationIdLoading: false,
                getAnswersByEvaluationIdSuccess: false,
                getAnswersByEvaluationIdFailure: true,
                getAnswersByEvaluationIdError: action.payload,
            }
        case FEEDBACK_REQUEST.GET_ANSWERS_BYEVALUATION_ID_SUCCESS:
            return {
                ...state,
                getAnswersByEvaluationIdLoading: false,
                getAnswersByEvaluationIdSuccess: true,
                getAnswersByEvaluationIdFailure: false,
                getAnswersByEvaluationIdError: null,
                AnswersByEvaluation: action.payload,
            }
        case FEEDBACK_REQUEST.RESET_GET_ANSWERS_BY_EVALUATION_ID:
            return {
                ...state,
                getAnswersByEvaluationIdLoading: false,
                getAnswersByEvaluationIdSuccess: false,
                getAnswersByEvaluationIdFailure: false,
                getAnswersByEvaluationIdError: null,
                AnswersByEvaluation: [],
            }
        case FEEDBACK_REQUEST.GET_FILTERED_EVALUATION_REQUEST:
            return {
                ...state,
                getFilteredEvaluationIdLoading: true,
                getFilteredEvaluationIdSuccess: false,
                getFilteredEvaluationIdFailure: false,
                getFilteredEvaluationIdError: null,
            }
        case FEEDBACK_REQUEST.GET_FILTERED_EVALUATION_FAILURE:
            return {
                ...state,
                getFilteredEvaluationIdLoading: false,
                getFilteredEvaluationIdSuccess: false,
                getFilteredEvaluationIdFailure: true,
                getFilteredEvaluationIdError: action.payload,
            }
        case FEEDBACK_REQUEST.GET_FILTERED_EVALUATION_SUCCESS:
            return {
                ...state,
                getFilteredEvaluationIdLoading: false,
                getFilteredEvaluationIdSuccess: true,
                getFilteredEvaluationIdFailure: false,
                getFilteredEvaluationIdError: null,
                FilteredEvaluation: action.payload,
            }
        default:
            return state;
    }
};